if (!customElements.get('scroll-to-top')) {
  customElements.define(
    'scroll-to-top',
    class ScrollToTop extends HTMLElement {
      constructor() {
        super();

        this.scrollToTop = this.scrollToTop.bind(this);
        this.handleScroll = this.handleScroll.bind(this);

        this.initialised = false;
      }

      connectedCallback() {
        if (this.parentElement !== document.body) {
          document.body.append(this); //move to body
          return; //event listeners will be added after move
        }
        this.elementAfterAppear = document.getElementById(this.dataset.elementAfterAppearId);
        this.setShowState();

        this.addEventListener('click',this.scrollToTop);
        if (this.elementAfterAppear) {
            window.addEventListener('scroll',this.handleScroll, { passive: true });
        }
        this.initialised = true;
      }

      disconnectedCallback() {
        if (!this.initialised) return;
        this.removeEventListener('click',this.scrollToTop);
        window.removeEventListener('scroll',this.handleScroll);
        this.initialised = false;
      }

      scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        //remove any href to avoid unwanted scrolling if the user reloads the page
        const urlSplit = window.location.href.split('#');
        if (urlSplit.length > 0) {
          window.history.replaceState({}, '', urlSplit[0]);
        }
      }

      handleScroll() {
        if (!this.elementAfterAppear) return;
        this.setShowState();
      }

      setShowState() {
        if (!this.elementAfterAppear) {
          this.hide();
          return;
        };
        if (this.elementAfterAppear.getBoundingClientRect().top < this.getBoundingClientRect().top) {
            this.show();
        } else {
            this.hide();
        }
      }

      show() {
        this.classList.remove('hidden');
      }

      hide() {
        this.classList.add('hidden');
      }

      moveToBody() {
        this.parentElementBeforeAppend = this.parentElement;
      }
    })
}